var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkOut24 = function SvgLinkOut24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.151 10.713c0 .557.414 1.009.925 1.009.51 0 .924-.452.924-1.009V5.008C20 4.452 19.586 4 19.076 4h-5.23c-.51 0-.924.452-.924 1.008 0 .557.414 1.009.924 1.009h2.998l-5.573 6.261a1.074 1.074 0 0 0 0 1.427.87.87 0 0 0 1.307 0l5.573-6.262v3.27Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5a1 1 0 0 1-1 1H9a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3 1 1 0 1 1 2 0 5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5h1a1 1 0 0 1 1 1Z",
    fill: "currentColor"
  })));
};
export default SvgLinkOut24;